
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";
import { useMarketplaceFavorites } from "@/hooks/useMarketplaceFavorites";

interface FavoriteButtonProps {
  serviceId: string;
  className?: string;
  size?: "sm" | "md" | "lg";
  variant?: "icon" | "button";
}

export const FavoriteButton = ({ 
  serviceId, 
  className = "", 
  size = "md",
  variant = "icon"
}: FavoriteButtonProps) => {
  const { isFavorite, toggleFavorite } = useMarketplaceFavorites();
  const [isLoading, setIsLoading] = useState(false);
  const isFav = isFavorite(serviceId);

  const handleToggleFavorite = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    setIsLoading(true);
    await toggleFavorite(serviceId);
    setIsLoading(false);
  };

  const sizeClasses = {
    sm: "h-7 w-7 p-1",
    md: "h-9 w-9 p-1.5",
    lg: "h-10 w-10 p-2"
  };

  const iconSizes = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6"
  };

  if (variant === "icon") {
    return (
      <button 
        className={`${
          isFav 
            ? 'bg-red-500 text-white' 
            : 'bg-white/80 text-gray-600 hover:bg-white'
        } transition-colors shadow-sm backdrop-blur-sm rounded-full ${sizeClasses[size]} ${className}`}
        onClick={handleToggleFavorite}
        disabled={isLoading}
        aria-label={isFav ? "Retirer des favoris" : "Ajouter aux favoris"}
      >
        <Heart className={`${iconSizes[size]} ${isFav ? 'fill-white' : ''}`} />
      </button>
    );
  }

  return (
    <Button
      variant={isFav ? "destructive" : "outline"}
      size="sm"
      className={className}
      onClick={handleToggleFavorite}
      disabled={isLoading}
    >
      <Heart className={`mr-2 h-4 w-4 ${isFav ? 'fill-white' : ''}`} />
      {isFav ? "Retirer des favoris" : "Ajouter aux favoris"}
    </Button>
  );
};
